import { render } from "./AnnotationsTab.vue?vue&type=template&id=53dd8ac8&scoped=true"
import script from "./AnnotationsTab.vue?vue&type=script&lang=js"
export * from "./AnnotationsTab.vue?vue&type=script&lang=js"

import "./AnnotationsTab.vue?vue&type=style&index=0&id=53dd8ac8&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53dd8ac8"]])

export default __exports__